import DlqiPhase from '@/components/AttendanceForm/general/phase/DlqiPhase.vue'
import ExaminationsPhase from '@/components/AttendanceForm/general/phase/ExaminationsPhase'
import FamilyHistoryPhase from '@/components/AttendanceForm/general/phase/FamilyHistoryPhase.vue'
import FlaresPhase from '@/components/AttendanceForm/general/phase/FlaresPhase.vue'
import ImagePhase from '@/components/AttendanceForm/general/phase/ImagePhase.vue'
import LmePhase from '@/components/AttendanceForm/general/phase/LmePhase.vue'
import MedicinesPhase from '@/components/AttendanceForm/general/phase/MedicinesPhase.vue'
import PasiBsaPhase from '@/components/AttendanceForm/general/phase/PasiBsaPhase.vue'
import PersonalHistoryPhase from '@/components/AttendanceForm/general/phase/PersonalHistoryPhase.vue'
import PsychiatricScreeningPhase from '@/components/AttendanceForm/general/phase/PsychiatricScreeningPhase.vue'
import VaccinationPhase from '@/components/AttendanceForm/general/phase/VaccinationPhase.vue'
import PsoriasisAffectedAreasPhase from '@/components/AttendanceForm/psoriasis/phase/PsoriasisAffectedAreasPhase.vue'
import PsoriasisHypothesisPhase from '@/components/AttendanceForm/psoriasis/phase/PsoriasisHypothesisPhase.vue'
import PsoriasisJointInvestigationPhase from '@/components/AttendanceForm/psoriasis/phase/PsoriasisJointInvestigationPhase.vue'
import PsoriasisReportPhase from '@/components/AttendanceForm/psoriasis/phase/PsoriasisReportPhase.vue'
import PsoriasisSpecificDataPhase from '@/components/AttendanceForm/psoriasis/phase/PsoriasisSpecificDataPhase.vue'
import PsoriasisHypothesis from '@/components/AttendanceForm/psoriasis/summary/PsoriasisHypothesis.vue'
import PsoriasisSummary from '@/components/AttendanceForm/psoriasis/summary/PsoriasisSummary.vue'
import { MEDICINE_CATEGORIES } from '@/constants/medicine'
import { util } from '@/plugins/util'
import { AttendanceConfig } from './AttendanceConfig'
import PsoriasisSpecificDataPhaseV2 from '@/components/AttendanceForm/psoriasis/phase/v2/PsoriasisSpecificDataPhaseV2.vue'

import {
  generateFamilyHistoryOverview,
  generateNotesOverview,
  generatePersonalHistoryOverview,
  generatePsychiatricScreenOverview,
} from './defaultConfig'
import PsoriasisJointInvestigationPhaseV2
  from '@/components/AttendanceForm/psoriasis/phase/v2/PsoriasisJointInvestigationPhaseV2.vue'
import MedicalHistoryPhase from '@/components/AttendanceForm/psoriasis/phase/v2/MedicalHistoryPhase.vue'
import PsoriasisAffectedAreasPhaseV2
  from '@/components/AttendanceForm/psoriasis/phase/v2/PsoriasisAffectedAreasPhaseV2.vue'
import ImageAndExamsPhase from '@/components/AttendanceForm/psoriasis/phase/v2/ImageAndExamsPhase.vue'
import MedicinesPhaseV2 from '@/components/AttendanceForm/psoriasis/phase/v2/MedicinesPhaseV2.vue'
import PsoriasisReportPhaseV2 from '@/components/AttendanceForm/psoriasis/phase/v2/PsoriasisReportPhaseV2.vue'
import PasiBsaPhaseV2 from '@/components/AttendanceForm/psoriasis/phase/v2/PasiBsaPhaseV2.vue'
import DlqiPhaseV2 from '@/components/AttendanceForm/psoriasis/phase/v2/DlqiPhaseV2.vue'
import PsoriasisHypothesisV2 from '@/components/AttendanceForm/psoriasis/phase/v2/PsoriasisHypothesisV2.vue'

export const configV1 = new AttendanceConfig()
  .addStep('Anamnese')
  .addPhase('dados_especificos', 'Dados específicos', PsoriasisSpecificDataPhase, generateSpecificDataOverview)
  .addPhase(
    'investigacao_articular',
    'Investigação articular',
    PsoriasisJointInvestigationPhase,
    generateJointInvestigationOverview,
  )
  .addPhase('investigacao_pessoal', 'Investigação pessoal', PersonalHistoryPhase, generatePersonalHistoryOverview)
  .addPhase('investigacao_familiar', 'Investigação familiar', FamilyHistoryPhase, generateFamilyHistoryOverview)
  .addPhase(
    'triagem_psiquiatrica',
    'Triagem psiquiátrica',
    PsychiatricScreeningPhase,
    generatePsychiatricScreenOverview,
    false,
  )
  .addStep('Exame físico')
  .addPhase('areas_afetadas', 'Áreas afetadas', PsoriasisAffectedAreasPhase, generateNotesOverview)
  .addPhase('pasi_bsa', 'PASI + BSA', PasiBsaPhase, generateNotesOverview)
  .addPhase('dlqi', 'DLQI', DlqiPhase, generateNotesOverview)
  .addPhase('exames', 'Exames', ExaminationsPhase)
  .addPhase('crises', 'Crises (Flares)', FlaresPhase, generateNotesOverview, false)
  .addPhase('vacinas', 'Vacinas', VaccinationPhase, generateNotesOverview, false)
  .addPhase('imagens', 'Imagens', ImagePhase)
  .addStep('Resultados')
  .addPhase('hipotese', 'Hipótese', PsoriasisHypothesisPhase, false)
  .addPhase('medicamentos', 'Medicamentos', MedicinesPhase, false)
  .addPhase('relatorio_medico', 'Relatório médico', PsoriasisReportPhase, false)
  .addPhase('lme', 'LME', LmePhase, false)

  .setSummaryComponent(PsoriasisSummary)
  .setHypothesisComponent(PsoriasisHypothesis)

export const configV2 = new AttendanceConfig()
  .addStep('Anamnese')
  .addPhase('dados_especificos', 'Dados específicos', PsoriasisSpecificDataPhaseV2, generateSpecificDataOverview)
  .addPhase(
    'investigacao_articular',
    'Investigação articular',
    PsoriasisJointInvestigationPhaseV2,
    generateJointInvestigationOverview,
  )
  .addPhase('antecedentes', 'Antecedentes', MedicalHistoryPhase, generatePersonalHistoryOverview)
  .addStep('Exame físico')
  .addPhase('areas_afetadas', 'Áreas afetadas', PsoriasisAffectedAreasPhaseV2, generateNotesOverview)
  .addPhase('pasi_bsa', 'PASI + BSA', PasiBsaPhaseV2, generateNotesOverview)
  .addPhase('dlqi', 'DLQI', DlqiPhaseV2, generateNotesOverview)
  .addPhase('imagens_exames', 'Imagens e Exames', ImageAndExamsPhase)
  .addStep('Resultados')
  .addPhase('medicamentos', 'Medicamentos', MedicinesPhaseV2, false)
  .addPhase('relatorio', 'Relatório', PsoriasisReportPhaseV2, false)

  .setSummaryComponent(PsoriasisSummary)
  .setHypothesisComponent(PsoriasisHypothesisV2)

function generateSpecificDataOverview(data, attendance) {
  if (!data) {
    return []
  }
  const paragraphs = []

  const affectedAreas = attendance.data.areas_afetadas?.areas_afetadas || {}

  if (!!data.ano_diagnostico_psoriase?.value) {
    const affectedAreaClasses = [
      ...new Set(
        Object.values(affectedAreas)
          .filter((a) => a.selected)
          .map((a) => a.classKey.toLowerCase()),
      ),
    ]

    paragraphs.push(
      `Psoríase desde ${data.ano_diagnostico_psoriase.value} ${
        affectedAreaClasses.length > 0 ? 'com o(s) subtipo(s):' + ' ' + affectedAreaClasses.join(', ') : ''
      }`,
    )
  }

  if (Object.values(affectedAreas).filter((a) => a.selected).length === 0) {
    paragraphs.push('atualmente sem lesões')
  }

  const selectedTreatments = Object.keys(data.medicines || {})
    .map((key) => data.medicines[key])
    .sort(util.objectSorter((item) => item.medicine.category.name.toLowerCase() + item.medicine.name.toLowerCase()))

  const currentTreatments = selectedTreatments
    .filter((medicine) => medicine.periods.length === 0 || !medicine.periods.find((period) => period.end))
    .map((medicine) => formattedCurrentMedicineText(medicine))

  const previousSistemicTreatments = selectedTreatments
    .filter(
      (m) =>
        m.medicine.category.id === MEDICINE_CATEGORIES.SISTEMICOS_TRADICIONAIS &&
        m.periods.find((period) => period.end),
    )
    .map((medicine) => formattedPreviousMedicineText(medicine))

  const previousImmunobiologicalTreatments = selectedTreatments
    .filter(
      (m) => m.medicine.category.id === MEDICINE_CATEGORIES.IMUNOBIOLOGICOS && m.periods.find((period) => period.end),
    )
    .map((medicine) => formattedPreviousMedicineText(medicine))

  const previousTopicalTreatments = selectedTreatments
    .filter((m) => m.medicine.category.id === MEDICINE_CATEGORIES.TOPICOS && m.periods.find((period) => period.end))
    .map((medicine) => formattedPreviousMedicineText(medicine))

  const fototerapicSessions = data.numero_sessoes_fototerapia?.value

  const fototerapicSessionsText = fototerapicSessions
    ? `${fototerapicSessions > 1 ? fototerapicSessions + ' sessões' : fototerapicSessions + ' sessão'}`
    : 'nenhuma sessão informada'

  const previousAntiInflammatoryTreatments = selectedTreatments
    .filter(
      (m) =>
        m.medicine.category.id === MEDICINE_CATEGORIES.ANTI_INFLAMATORIOS && m.periods.find((period) => period.end),
    )
    .map((medicine) => formattedPreviousMedicineText(medicine))

  paragraphs.push(
    '\nHistórico de medicamentos:',
    `    - Medicamentos atuais: ${currentTreatments.length > 0 ? currentTreatments : 'nenhum'};`,
    `    - DMARDs e sistêmicos não biológicos prévios: ${
      previousSistemicTreatments.length > 0 ? previousSistemicTreatments : 'nenhum'
    };`,
    `    - Imunobiológicos ou pequenas moléculas prévios: ${
      previousImmunobiologicalTreatments.length > 0 ? previousImmunobiologicalTreatments : 'nenhum'
    };`,
    `    - Tópicos prévios: ${previousTopicalTreatments.length > 0 ? previousTopicalTreatments : 'nenhum'}.`,
    `    - Fototerápicos prévios: ${fototerapicSessionsText}.`,
    `    - Anti-inflamatórios prévios: ${
      previousAntiInflammatoryTreatments > 0 ? previousAntiInflammatoryTreatments : 'nenhum'
    }.\n`,
  )

  if (data['diagnostico_psoriase']?.value) {
    const diagnosisYear = parseInt(data.ano_diagnostico_psoriase?.value)
    if (diagnosisYear) {
      paragraphs.push(`Diagnosticado previamente em ${diagnosisYear}.`)
    }
  } else {
    paragraphs.push(`Sem diagnóstico prévio de psoríase.`)
  }

  if (data['biopsia_previa']?.value) {
    paragraphs.push(`Houve biópsia prévia.`)
  } else {
    paragraphs.push(`Não houve biópsia prévia.`)
  }

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}

function formattedCurrentMedicineText(medicine) {
  return `${medicine.medicine.name.firstLetterToLowercase()}${
    medicine.periods.length === 0 || medicine.periods.some((p) => !p.start)
      ? ''
      : ' (desde ' + util.toFormattedDate(medicine.periods.find((p) => !p.end).start) + ')'
  }`
}

function formattedPreviousMedicineText(medicine) {
  return `${medicine.medicine.name.firstLetterToLowercase()}`
}

function generateJointInvestigationOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  const areasAfetadas = data.areas_afetadas || {}

  const classes = [
    ...new Set(
      Object.values(areasAfetadas)
        .filter((a) => a.selected)
        .map((a) => a.classKey),
    ),
  ]

  for (let areaClass of classes) {
    paragraphs.push(areaClass)
    Object.values(areasAfetadas)
      .filter((a) => a.selected)
      .map((a) => a.label)
      .forEach((area) => {
        paragraphs.push(area)
      })
  }

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}
